import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(getNextRefPos);
import { revcom } from '@jbrowse/core/util';
var mdRegex = new RegExp(/(\d+|\^[a-z]+|[a-z])/gi);
var modificationRegex = new RegExp(/([A-Z])([-+])([^,.?]+)([.?])?/);
var cigarRegex = new RegExp(/([MIDNSHPX=])/);
var startClip = new RegExp(/(\d+)[SH]$/);
var endClip = new RegExp(/^(\d+)([SH])/);
export function parseCigar() {
  var cigar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return cigar.split(cigarRegex).slice(0, -1);
}
export function cigarToMismatches(ops, seq, ref, qual) {
  var roffset = 0; // reference offset
  var soffset = 0; // seq offset
  var mismatches = [];
  var hasRefAndSeq = ref && seq;
  for (var i = 0; i < ops.length; i += 2) {
    var len = +ops[i];
    var op = ops[i + 1];
    if (op === 'M' || op === '=' || op === 'E') {
      if (hasRefAndSeq) {
        for (var j = 0; j < len; j++) {
          if (
          // @ts-ignore in the full yarn build of the repo, this says that object is possibly undefined for some reason, ignored
          seq[soffset + j].toUpperCase() !== ref[roffset + j].toUpperCase()) {
            mismatches.push({
              start: roffset + j,
              type: 'mismatch',
              base: seq[soffset + j],
              altbase: ref[roffset + j],
              length: 1
            });
          }
        }
      }
      soffset += len;
    }
    if (op === 'I') {
      mismatches.push({
        start: roffset,
        type: 'insertion',
        base: "".concat(len),
        length: 0
      });
      soffset += len;
    } else if (op === 'D') {
      mismatches.push({
        start: roffset,
        type: 'deletion',
        base: '*',
        length: len
      });
    } else if (op === 'N') {
      mismatches.push({
        start: roffset,
        type: 'skip',
        base: 'N',
        length: len
      });
    } else if (op === 'X') {
      var r = (seq === null || seq === void 0 ? void 0 : seq.slice(soffset, soffset + len)) || [];
      var q = (qual === null || qual === void 0 ? void 0 : qual.slice(soffset, soffset + len)) || [];
      for (var _j = 0; _j < len; _j++) {
        mismatches.push({
          start: roffset + _j,
          type: 'mismatch',
          base: r[_j],
          qual: q[_j],
          length: 1
        });
      }
      soffset += len;
    } else if (op === 'H') {
      mismatches.push({
        start: roffset,
        type: 'hardclip',
        base: "H".concat(len),
        cliplen: len,
        length: 1
      });
    } else if (op === 'S') {
      mismatches.push({
        start: roffset,
        type: 'softclip',
        base: "S".concat(len),
        cliplen: len,
        length: 1
      });
      soffset += len;
    }
    if (op !== 'I' && op !== 'S' && op !== 'H') {
      roffset += len;
    }
  }
  return mismatches;
}
/**
 * parse a SAM MD tag to find mismatching bases of the template versus the reference
 * @returns array of mismatches and their positions
 */
export function mdToMismatches(mdstring, ops, cigarMismatches, seq, qual) {
  var mismatchRecords = [];
  var curr = {
    start: 0,
    base: '',
    length: 0,
    type: 'mismatch'
  };
  var skips = cigarMismatches.filter(function (cigar) {
    return cigar.type === 'skip';
  });
  var lastCigar = 0;
  var lastTemplateOffset = 0;
  var lastRefOffset = 0;
  var lastSkipPos = 0;
  // convert a position on the reference sequence to a position
  // on the template sequence, taking into account hard and soft
  // clipping of reads
  function nextRecord() {
    mismatchRecords.push(curr);
    // get a new mismatch record ready
    curr = {
      start: curr.start + curr.length,
      length: 0,
      base: '',
      type: 'mismatch'
    };
  }
  function getTemplateCoordLocal(refCoord) {
    var templateOffset = lastTemplateOffset;
    var refOffset = lastRefOffset;
    for (var i = lastCigar; i < ops.length && refOffset <= refCoord; i += 2, lastCigar = i) {
      var len = +ops[i];
      var op = ops[i + 1];
      if (op === 'S' || op === 'I') {
        templateOffset += len;
      } else if (op === 'D' || op === 'P' || op === 'N') {
        refOffset += len;
      } else if (op !== 'H') {
        templateOffset += len;
        refOffset += len;
      }
    }
    lastTemplateOffset = templateOffset;
    lastRefOffset = refOffset;
    return templateOffset - (refOffset - refCoord);
  }
  // now actually parse the MD string
  var md = mdstring.match(mdRegex) || [];
  for (var i = 0; i < md.length; i++) {
    var token = md[i];
    var num = +token;
    if (!Number.isNaN(num)) {
      curr.start += num;
    } else if (token.startsWith('^')) {
      curr.start += token.length - 1;
    } else {
      // mismatch
      for (var j = 0; j < token.length; j += 1) {
        curr.length = 1;
        while (lastSkipPos < skips.length) {
          var mismatch = skips[lastSkipPos];
          if (curr.start >= mismatch.start) {
            curr.start += mismatch.length;
            lastSkipPos++;
          } else {
            break;
          }
        }
        var s = getTemplateCoordLocal(curr.start);
        curr.base = seq[s] || 'X';
        curr.qual = qual === null || qual === void 0 ? void 0 : qual[s];
        curr.altbase = token;
        nextRecord();
      }
    }
  }
  return mismatchRecords;
}
export function getMismatches(cigar, md, seq, ref, qual) {
  var mismatches = [];
  var ops = parseCigar(cigar);
  // parse the CIGAR tag if it has one
  if (cigar) {
    mismatches = mismatches.concat(cigarToMismatches(ops, seq, ref, qual));
  }
  // now let's look for CRAM or MD mismatches
  if (md && seq) {
    mismatches = mismatches.concat(mdToMismatches(md, ops, mismatches, seq, qual));
  }
  return mismatches;
}
// get relative reference sequence positions for positions given relative to
// the read sequence
export function getNextRefPos(cigarOps, positions) {
  var readPos, refPos, currPos, i, len, op, _i, _i2;
  return _regeneratorRuntime().wrap(function getNextRefPos$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        readPos = 0;
        refPos = 0;
        currPos = 0;
        i = 0;
      case 4:
        if (!(i < cigarOps.length && currPos < positions.length)) {
          _context.next = 31;
          break;
        }
        len = +cigarOps[i];
        op = cigarOps[i + 1];
        if (!(op === 'S' || op === 'I')) {
          _context.next = 12;
          break;
        }
        for (_i = 0; _i < len && currPos < positions.length; _i++) {
          if (positions[currPos] === readPos + _i) {
            currPos++;
          }
        }
        readPos += len;
        _context.next = 28;
        break;
      case 12:
        if (!(op === 'D' || op === 'N')) {
          _context.next = 16;
          break;
        }
        refPos += len;
        _context.next = 28;
        break;
      case 16:
        if (!(op === 'M' || op === 'X' || op === '=')) {
          _context.next = 28;
          break;
        }
        _i2 = 0;
      case 18:
        if (!(_i2 < len && currPos < positions.length)) {
          _context.next = 26;
          break;
        }
        if (!(positions[currPos] === readPos + _i2)) {
          _context.next = 23;
          break;
        }
        _context.next = 22;
        return refPos + _i2;
      case 22:
        currPos++;
      case 23:
        _i2++;
        _context.next = 18;
        break;
      case 26:
        readPos += len;
        refPos += len;
      case 28:
        i += 2;
        _context.next = 4;
        break;
      case 31:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
export function getModificationPositions(mm, fseq, fstrand) {
  var seq = fstrand === -1 ? revcom(fseq) : fseq;
  var mods = mm.split(';').filter(function (mod) {
    return !!mod;
  });
  var result = [];
  for (var i = 0; i < mods.length; i++) {
    var mod = mods[i];
    var _mod$split = mod.split(','),
      _mod$split2 = _toArray(_mod$split),
      basemod = _mod$split2[0],
      skips = _mod$split2.slice(1); // regexes based on parse_mm.pl from hts-specs
    var matches = basemod.match(modificationRegex);
    if (!matches) {
      throw new Error('bad format for MM tag');
    }
    var _matches = _slicedToArray(matches, 4),
      base = _matches[1],
      strand = _matches[2],
      typestr = _matches[3]; // can be a multi e.g. C+mh for both meth (m) and hydroxymeth (h) so
    // split, and they can also be chemical codes (ChEBI) e.g. C+16061
    var types = typestr.split(/(\d+|.)/).filter(function (f) {
      return !!f;
    });
    if (strand === '-') {
      console.warn('unsupported negative strand modifications');
      // make sure to return a somewhat matching type even in this case
      result.push({
        type: 'unsupported',
        positions: []
      });
    }
    // this logic also based on parse_mm.pl from hts-specs is that in the
    // sequence of the read, if we have a modification type e.g. C+m;2 and a
    // sequence ACGTACGTAC we skip the two instances of C and go to the last
    // C
    for (var j = 0; j < types.length; j++) {
      var type = types[j];
      var _i3 = 0;
      var positions = [];
      for (var k = 0; k < skips.length; k++) {
        var delta = +skips[k];
        do {
          if (base === 'N' || base === seq[_i3]) {
            delta--;
          }
          _i3++;
        } while (delta >= 0 && _i3 < seq.length);
        var temp = _i3 - 1;
        positions.push(fstrand === -1 ? seq.length - 1 - temp : temp);
      }
      if (fstrand === -1) {
        positions.sort(function (a, b) {
          return a - b;
        });
      }
      result.push({
        type: type,
        positions: positions
      });
    }
  }
  return result;
}
export function getModificationTypes(mm) {
  var mods = mm.split(';');
  return mods.filter(function (mod) {
    return !!mod;
  }).map(function (mod) {
    var _mod$split3 = mod.split(','),
      _mod$split4 = _slicedToArray(_mod$split3, 1),
      basemod = _mod$split4[0];
    var matches = basemod.match(modificationRegex);
    if (!matches) {
      throw new Error("bad format for MM tag: ".concat(mm));
    }
    var _matches2 = _slicedToArray(matches, 4),
      typestr = _matches2[3]; // can be a multi e.g. C+mh for both meth (m) and hydroxymeth (h) so
    // split, and they can also be chemical codes (ChEBI) e.g. C+16061
    return typestr.split(/(\d+|.)/).filter(function (f) {
      return !!f;
    });
  }).flat();
}
export function getOrientedCigar(flip, cigar) {
  if (flip) {
    var ret = [];
    for (var i = 0; i < cigar.length; i += 2) {
      var len = cigar[i];
      var op = cigar[i + 1];
      if (op === 'D') {
        op = 'I';
      } else if (op === 'I') {
        op = 'D';
      }
      ret.push(len);
      ret.push(op);
    }
    return ret;
  } else {
    return cigar;
  }
}
export function getOrientedMismatches(flip, cigar) {
  var p = parseCigar(cigar);
  return cigarToMismatches(flip ? getOrientedCigar(flip, p) : p);
}
export function getLengthOnRef(cigar) {
  var cigarOps = parseCigar(cigar);
  var lengthOnRef = 0;
  for (var i = 0; i < cigarOps.length; i += 2) {
    var len = +cigarOps[i];
    var op = cigarOps[i + 1];
    if (op !== 'H' && op !== 'S' && op !== 'I') {
      lengthOnRef += len;
    }
  }
  return lengthOnRef;
}
export function getLength(cigar) {
  var cigarOps = parseCigar(cigar);
  var length = 0;
  for (var i = 0; i < cigarOps.length; i += 2) {
    var len = +cigarOps[i];
    var op = cigarOps[i + 1];
    if (op !== 'D' && op !== 'N') {
      length += len;
    }
  }
  return length;
}
export function getLengthSansClipping(cigar) {
  var cigarOps = parseCigar(cigar);
  var length = 0;
  for (var i = 0; i < cigarOps.length; i += 2) {
    var len = +cigarOps[i];
    var op = cigarOps[i + 1];
    if (op !== 'H' && op !== 'S' && op !== 'D' && op !== 'N') {
      length += len;
    }
  }
  return length;
}
export function getClip(cigar, strand) {
  return strand === -1 ? +(cigar.match(startClip) || [])[1] || 0 : +(cigar.match(endClip) || [])[1] || 0;
}
export function getTag(f, tag) {
  var tags = f.get('tags');
  return tags ? tags[tag] : f.get(tag);
}
// produces a list of "feature-like" object from parsing supplementary
// alignments in the SA tag
//
// @param normalize - used specifically in the linear-read-vs-ref context, it
// flips features around relative to the original feature. other contexts of
// usage can keep this false
export function featurizeSA(SA, id, strand, readName, normalize) {
  return (SA === null || SA === void 0 ? void 0 : SA.split(';').filter(function (aln) {
    return !!aln;
  }).map(function (aln, index) {
    var _aln$split = aln.split(','),
      _aln$split2 = _slicedToArray(_aln$split, 4),
      saRef = _aln$split2[0],
      saStart = _aln$split2[1],
      saStrand = _aln$split2[2],
      saCigar = _aln$split2[3];
    var saLengthOnRef = getLengthOnRef(saCigar);
    var saLength = getLength(saCigar);
    var saLengthSansClipping = getLengthSansClipping(saCigar);
    var saStrandNormalized = saStrand === '-' ? -1 : 1;
    var saClipPos = getClip(saCigar, (normalize ? strand : 1) * saStrandNormalized);
    var saRealStart = +saStart - 1;
    return {
      refName: saRef,
      start: saRealStart,
      end: saRealStart + saLengthOnRef,
      seqLength: saLength,
      clipPos: saClipPos,
      CIGAR: saCigar,
      strand: (normalize ? strand : 1) * saStrandNormalized,
      uniqueId: "".concat(id, "_SA").concat(index),
      mate: {
        start: saClipPos,
        end: saClipPos + saLengthSansClipping,
        refName: readName
      }
    };
  })) || [];
}